import React, { useState, useEffect, useCallback } from "react";
import { Maximize2, Minimize2 } from "lucide-react";

const FullScreen = ({ onToggleFullscreen }) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const checkFullscreenStatus = useCallback(() => {
    setIsFullscreen(!!document.fullscreenElement);
  }, []);

  useEffect(() => {
    document.addEventListener("fullscreenchange", checkFullscreenStatus);
    checkFullscreenStatus();
    return () => {
      document.removeEventListener("fullscreenchange", checkFullscreenStatus);
    };
  }, [checkFullscreenStatus]);

  const handleFullscreenToggle = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.error("Error al solicitar pantalla completa:", err);
      });
    } else {
      document.exitFullscreen().catch((err) => {
        console.error("Error al salir de pantalla completa:", err);
      });
    }

    if (onToggleFullscreen) onToggleFullscreen();
  };

  return (
    <button
      className="nav-icon-circle"
      onClick={handleFullscreenToggle}
      title={isFullscreen ? "Salir de pantalla completa" : "Pantalla completa"}
      type="button"
    >
      {isFullscreen ? <Minimize2 size={20} /> : <Maximize2 size={20} />}
    </button>
  );
};

export default FullScreen;
